// src/components/TabsSplitView.jsx
import React, { useState } from "react";

const TabsSplitView = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div>
      {/* Onglets */}
      <div style={{ display: "flex", borderBottom: "1px solid #ddd" }}>
        {tabs.map((tab, index) => (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            style={{
              padding: "8px 16px",
              cursor: "pointer",
              borderBottom:
                activeTab === index ? "3px solid #007bff" : "3px solid transparent",
              color: activeTab === index ? "#007bff" : "#555",
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {/* Contenu */}
      <div style={{ padding: "16px" }}>{tabs[activeTab].content}</div>
    </div>
  );
};

export default TabsSplitView;
